import React, { Component } from 'react';
import { Button, Input } from 'react-bootstrap';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';
import ConfirmActionModal from '../../../components/Common/confirmActionModal';
import Spinner from '../../../components/Widgets/spinner';
class NewWeightView extends Component {

  constructor() {
    super();
    this.state = {
      weights: {
        rows: [],
        sortColumn: null,
        sortDirection: null,
      },
      confirmOpen: false,
      case: 'zeroWeight',
      selectedWeightIdx: 1,
      selectedWeight: '',
      batchTotalWt: 0,
      totalWtValue: 0,
    };
  }

  componentDidMount() {
    let rows = [...this.props.currentWeights];
    if (rows.length < this.props.totalLoaded) {
      const temp = rows.length;
      for (var i = 0; i < (this.props.totalLoaded - temp); i++) {
        rows.push({ weight: 0 });
      }
    }

    if ((parseFloat(this.props.totalLoaded) < rows.length)) {
      let replace = [];
      for (let i = 0; i < parseFloat(this.props.totalLoaded); i++) {
        replace.push(rows[i]);
      }
      rows = [...replace];
    }
    const weights = { ...this.state.weights, rows };
    this.props.setRemainWts(weights.rows);
    this.setState({ weights, batchTotalWt: this.props.batchTotalWt });
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.batchTotalWt != this.props.batchTotalWt) {
      this.setState({ batchTotalWt: nextProps.batchTotalWt });
    }
    if (nextProps.totalLoaded != this.props.totalLoaded) {
      let rows = [...this.props.currentWeights];
      if (rows.length < nextProps.totalLoaded) {
        const temp = rows.length;
        for (var i = 0; i < (nextProps.totalLoaded - temp); i++) {
          rows.push({ weight: 0 });
        }
      }

      if ((parseFloat(nextProps.totalLoaded) < rows.length)) {
        let replace = [];
        for (let i = 0; i < parseFloat(nextProps.totalLoaded); i++) {
          replace.push(rows[i]);
        }
        rows = [...replace];
      }
      const weights = { ...this.state.weights, rows };
      this.props.setRemainWts(weights.rows);
      this.setState({ weights });
    }
  }

  componentWillUnmount() {
    this.setState({
      weights: {
        rows: [],
        sortColumn: null,
        sortDirection: null,
      },
      confirmOpen: false,
      case: 'zeroWeight',
      selectedWeightIdx: 1,
      selectedWeight: '',
      batchTotalWt: 0,
    })
  }

  fillWithLastValue() {
    let index = 0;
    const newWeights = { ...this.state.weights };

    for (var i = 0; i < this.state.weights.rows.length; i++) {
      if (this.state.weights.rows[i].weight === 0) {
        index = i;
        break;
      }
    }

    if (index > 0) {
      const fillValue = this.state.weights.rows[index - 1].weight;

      for (var i = index; i < this.state.weights.rows.length; i++) {
        newWeights.rows[i].weight = fillValue;
      }
      this.setState({ weights: newWeights });
    }
  }

  clearAllValues() {
    const newWeights = [...this.state.weights.rows];
    newWeights.map((row) => {
      row.weight = 0;
    });
    const weights = { ...this.state.weights, rows: newWeights }
    this.setState({ weights })
  }

  handleKeyPress = (event) => {
    if (event.charCode === 13 && this.state.selectedWeight) {
      event.preventDefault();
      const weights = { ...this.state.weights };

      if (this.state.selectedWeightIdx === this.state.weights.rows.length) {
        weights.rows[this.state.selectedWeightIdx - 1].weight = this.state.selectedWeight;
        this.setState({ selectedWeight: '', selectedWeightIdx: 0, weights })
      } else if (this.state.selectedWeightIdx) {
        weights.rows[this.state.selectedWeightIdx - 1].weight = this.state.selectedWeight;
        this.setState({ selectedWeight: '', selectedWeightIdx: (this.state.selectedWeightIdx + 1), weights })
      } else {
        this.setState({ selectedWeight: '', selectedWeightIdx: (this.state.selectedWeightIdx + 1) }, () => { this.handleFinish(); });
      }
    } else if (event.charCode === 13 && this.state.selectedWeightIdx === 0) {
      this.setState({ selectedWeight: '', selectedWeightIdx: (this.state.selectedWeightIdx + 1) }, () => { this.handleFinish(); });
    }
  }

  handleChange = (event) => {
    let wt = event.target.value;
    if (wt) {
      wt = Number(wt)
    }
    this.setState({ selectedWeight: wt + '' });
  }

  handleChangeTotalWt = (totalWeight) => {
    this.setState({ totalWtValue: totalWeight })
  }

  handleEnterTotalWt = () => {
    let totalWtt = parseFloat(this.state.totalWtValue || 0);
    let qty = this.state.weights.rows.length || 1;
    let avgWeight = parseFloat(totalWtt / qty).toFixed(2);
    let remainder = parseFloat(totalWtt - avgWeight * qty).toFixed(2);
    let lastWt = parseFloat(Number(avgWeight) + Number(remainder)).toFixed(2);
    let wtRows = this.state.weights.rows.map((r, index) => {
      if (index == qty - 1) {
        return { weight: lastWt };
      } else {
        return { weight: avgWeight };
      }
    });
    this.setState({ weights: { ...this.state.weights, rows: wtRows } }, () => {
      this.handleFinish();
    });
  }

  renderWeightsSubmit = () => {
    const confirmWeights = (this.state.selectedWeightIdx === 0) ? <Translate value="press_enter_to_confirm_weights" /> : '';
    return (
      <div style={{ marginTop: '10px' }}>
        <h3><Translate value="set_weights" /></h3>
        <Input
          type="number"
          addonBefore={this.state.selectedWeightIdx || ''}
          name="selectedWeight"
          autoFocus
          value={this.state.selectedWeight}
          onChange={this.handleChange}
          onKeyPress={(event) => {
            this.handleKeyPress(event);
          }}
        />
        <span style={{ color: 'green' }}>{confirmWeights}</span>
      </div>
    );
  }
  renderSetTotalWeights = () => {
    return (
      <div>
        <h3><Translate value="set_total_weight" /></h3>
        <input
          ref='TotalWeight'
          style={{
            border: 'solid',
            borderWidth: '1px',
            fontSize: '14px',
            paddingLeft: '4px',
            borderRadius: '2px',
            width: '100%',
          }}
          value={this.state.totalWtValue}
          onChange={(e) => {
            this.handleChangeTotalWt(e.target.value)
          }}
          onKeyDown={(event) => {
            if (event.keyCode == 13) {
              this.handleEnterTotalWt();
            }
          }}
        />
      </div>
    );
  }

  renderWeightInputs() {
    const { salesOrderLineWeightsIsLoading, salesOrderLineWeightsError } = this.props;
    if (salesOrderLineWeightsIsLoading && !salesOrderLineWeightsError) { return <Spinner className="marginTopStyle" /> }
    else if (salesOrderLineWeightsError) { return (<div className="alert alert-danger">{JSON.stringify(salesOrderLineWeightsError)}</div>); }

    const getRows = () => Data.Selectors.getRows(this.state.weights);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return Object.assign({ Idx: rowIdx + 1 }, rows[rowIdx]);
    };

    const onRowClick = (rowIdx, row) => {
      this.setState({ selectedWeight: row.weight, selectedWeightIdx: row.Idx });
    };

    const handleRowUpdated = (e) => {
      const rows = getRows();
      const updated = { weight: parseFloat(e.updated.weight) };
      Object.assign(rows[e.rowIdx], updated);
      const weights = { ...this.state.weights, rows }
      this.setState({ weights });
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const weights = Object.assign({}, this.state.weights, { sortColumn, sortDirection });
      this.setState({ weights });
    };

    // Column difinition
    const ZeroFormatter = React.createClass({
      render() {
        if (this.props.value <= 0 && this.props.dependentValues.zeroFound) { return <div style={{ backgroundColor: 'yellow' }}>{this.props.value}</div>; }
        return <div>{this.props.value}</div>;
      },
    });

    const columns = [{
      name: <Translate value="action" />,
      width: 60,
      resizable: true,
      filterable: true,
      getRowMetaData: (row, idx) => ({ ...row, idx }),
      formatter: (props) => {
        return (<div
          style={{ width: '100%', textAlign: 'center' }}
        >
          <Button
            bsStyle="danger"
            className="textAlignStyle"
            type="button"
            onClick={() => {
              const rows = [...this.state.weights.rows];
              rows.splice(props.dependentValues.Idx - 1, 1);
              this.setState({
                weights: {
                  ...this.state.weights,
                  rows,
                }
              }, () => {
                this.handleFinish();
              })
            }}
          >X</Button>
        </div>)
      },
    },
    {
      key: 'Idx',
      name: <Translate value="idx" />,
      width: 30,
      resizable: false,
      filterable: true,
    },
    {
      key: 'weight',
      name: <Translate value="weight" />,
      width: 100,
      resizable: true,
      filterable: true,
      editable: true,
      formatter: ZeroFormatter,
      getRowMetaData: row => row,
    },
    ];
    return (
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ height: '375px', paddingLeft: '10px', marginTop: '18px' }}>
          <ReactDataGrid
            onGridSort={handleGridSort}
            columns={columns}
            enableCellSelect={true}
            rowHeight={25}
            rowGetter={rowGetter}
            rowsCount={getSize()}
            minHeight={375}
            minWidth={180}
            onRowClick={onRowClick}
            onRowUpdated={handleRowUpdated}
          />
        </div>
        <div style={{ marginTop: '18px', marginLeft: '20px', display: 'flex', flexDirection: 'column' }}>
          <button className="btn btn-primary"
            type="button"
            disabled={this.state.needsDelete}
            onClick={() => { this.fillWithLastValue(); }}>
            <Translate value="fill_with_latest_value" />
          </button>
          <button
            className="btn btn-danger"
            style={{ marginTop: '20px' }}
            type="button"
            onClick={() => { this.clearAllValues(); }}>
            <Translate value="clear_all_values" />
          </button>
          {this.renderWeightsSubmit()}
          {this.renderSetTotalWeights()}
          <button
            className="btn btn-primary"
            style={{ marginTop: '20px' }}
            type="button"
            onClick={() => { this.handleFinish(); }}>
            <Translate value="load_weights" />
          </button>
        </div>
      </div >
    );
  }

  openConfirm = () => this.setState({ confirmOpen: true });

  closeConfirm = () => this.setState({ confirmOpen: false, zeroInList: false });

  handleFinish = () => {
    let havZero = this.state.weights.rows.findIndex(row => !row.weight || row.weight == 0);
    if (havZero != -1) {
      alert('Weight can not be empty')
      return
    }
    let totalWeight = 0;
    const rows = [];
    this.state.weights.rows.map((row) => {
      if (row.weight) {
        let wt = parseFloat(row.weight);
        totalWeight += wt;
        rows.push({ weight: wt });
      }
    });
    this.props.returnTotalWeight(totalWeight.toFixed(2), rows);
  }

  render() {
    const createDialogStyle = {
      height: '200px',
      marginTop: '-20%',
      width: '300px',
      marginLeft: '-10%',
      left: '45%',
    };
    const confirmAction = (<Translate value="confirm_action" />);

    const { rows } = this.state.weights;
    let totalNetWeight = 0;
    rows.map((r) => {
      totalNetWeight += parseFloat(r.weight) || 0;
    });

    return (
      <div>
        <label style={{ color: 'orange', fontSize: '15px', paddingLeft: '10px' }}>
          <Translate value="remaining" /> WT: {totalNetWeight}-{this.state.batchTotalWt}={totalNetWeight - this.state.batchTotalWt}(RealWt - Shipped Wt)
        </label>
        <div style={{ height: '393px' }}>
          {this.renderWeightInputs()}
        </div>
        <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.confirmOpen} onCloseClicked={() => { this.closeConfirm(); }} title={confirmAction}>
          <ConfirmActionModal case={this.state.case} closeC={this.closeConfirm} />
        </SkyLightStateless>
      </div>
    );
  }
}

export default NewWeightView;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/components/NewWeightView.jsx